import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const dealjacketService = {
  getList,
  getDetail,
  uploadFile,
  uploadDocument,
  search,
  editJacketName,
  editDealJacket,
  getDealNumberMatches,
  createDealJacketFromDealNumber
};

async function getList(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/dealjacket";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getDealNumberMatches(org_id, deal_jacket_id) {
  // TODO consider "/org/" + org_id +
  const url = SERVER_URL + "/deal_number/" + deal_jacket_id;
  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getDetail(dealjacket_id) {
  const url = SERVER_URL + "/dealjacket/" + dealjacket_id;

  const pages = await customFetch("GET", url, null, null);
  return pages;
}

async function uploadFile(file_info) {
  const url = SERVER_URL + "/org/" + file_info.org_id + "/dealjacket";

  const result = await customFetch("MP-POST", url, null, file_info.form_data);

  return result;
}

async function uploadDocument(uploadObject) {
  const org_id = uploadObject.org_id;
  const doc_type = uploadObject.doc_type;
  const token = uploadObject.token;
  const form_data = uploadObject.form_data;
  const url = SERVER_URL + "/org" + org_id + "/dealjacket?token=" + token + "&doctype=" + doc_type;

  const result = await customFetch("MP-POST", url, null, form_data);

  return result;
}

async function search(searchRequest) {
  const { org_id, term, type, limit, offset, doctype } = searchRequest;
  let url;
  let querystring;
  if (type === "listAll") {
    url = SERVER_URL + "/org/" + org_id + "/dealjacket/search/all";
  } else {
    querystring = "q=" + type + "&t=" + term + "&l=" + limit + "&o=" + offset + "&d=" + doctype ;
    url = SERVER_URL + "/org/" + org_id + "/dealjacket/search?" + querystring;
  }
  const result = await customFetch("GET", url, null, null);
  result.query_string = querystring;
  return result;
}

async function editJacketName(jacket) {
  const url =
    SERVER_URL +
    "/org/" +
    jacket.org_id +
    "/dealjacket/" +
    jacket.deal_jacket_id;

  const result = await customFetch("PUT", url, null, JSON.stringify(jacket));
  return result;
}

async function editDealJacket(jacket) {
  const url =
    SERVER_URL +
    "/org/" +
    jacket.org_id +
    "/dealjacket/" +
    jacket.deal_jacket_id;

  const result = await customFetch("PUT", url, null, JSON.stringify(jacket));
  return result;
}

async function createDealJacketFromDealNumber(org_id, dealnumber) {
  const url = SERVER_URL + "/org/" + org_id + "/deal_number";
  const body = {
    deal_number: dealnumber
  }

  return await customFetch("POST", url, null, JSON.stringify(body));
}
